<template lang="html">
  <div class="pageContainer">
    <div class="container">
      <div class="row">
        <div id="error404" class="col-12 col-md-8 offset-md-2">
          <div class="header">
            <h1>This page isn't available</h1>
            <p>The link you followed may be broken, or the page may have been removed.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Error404',
  components: {

  },
  data() {
    return {

    }
  },
  methods: {

  }
}
</script>

<style lang="css" scoped>
.header {
  text-align: center;
  margin: 15px 0 0 0;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Error404.vue